import { Injectable } from '@angular/core'

import { patchState, signalState } from '@ngrx/signals'

interface AuthState {
  user: Record<string, any> | null
  roles: string[]
  isLogged: boolean
}

const initialState: AuthState = {
  user: null,
  roles: [],
  isLogged: false,
}

@Injectable({
  providedIn: 'root',
})
export class AuthStoreService {
  readonly authState = signalState<AuthState>(initialState)

  setUser(user: Record<string, any> | null): void {
    patchState(this.authState, { user })
  }

  setRoles(roles: string[]): void {
    patchState(this.authState, { roles })
  }

  setLogged(isLogged: boolean): void {
    patchState(this.authState, { isLogged })
  }

  clearAuth(): void {
    patchState(this.authState, { user: null, roles: [], isLogged: false })
  }
}
